import React, { useEffect } from 'react';
import ReactECharts from 'echarts-for-react'; // or var ReactECharts = require('echarts-for-react');
import { MenuItem, Menu } from 'semantic-ui-react';
import { Popup } from '../../lib/custom-ui';
import PropTypes from 'prop-types';
import api from '../../api';
import styles from './Statistics.module.scss';

const months = [
  '1月',
  '2月',
  '3月',
  '4月',
  '5月',
  '6月',
  '7月',
  '8月',
  '9月',
  '10月',
  '11月',
  '12月',
];
// 获取当前月份的天数
const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() + 1;
const daysInMonth = new Date(year, month, 0).getDate();

// 创建天数数组
const days = Array.from({ length: daysInMonth }, (_, i) => `${i + 1}号`);
const today = date.getDay();

// 计算当前星期的周一和周日的日期
const monday = new Date(date);
monday.setDate(date.getDate() - today + 1);

const Statistics = React.memo(() => {
  const [statistics, setStatistics] = React.useState({
    monthlyNewUsersCount: 0,
    monthlyActiveUserCounts: 0,
    monthlyNewUsers: 0,
    totalPaymentThisMonth: 0,
    newUsersThisMonth: 0,
    totalPrice: 0,
    totalNumberOfPeople: 0,
    totalUsers: 0,
  });
  const [activeItem, setActiveItem] = React.useState('2');
  const [array, setArray] = React.useState([[], [], [], []]);
  const timeArray = React.useMemo(() => {
    switch (activeItem) {
      case '0':
        // 返回按日的时间数组
        return days;
      case '1':
        // 返回按周的时间数组
        return [];
      case '2':
        // 返回按月的时间数组
        return months;
      default:
        // 默认返回空数组
        return [];
    }
  }, [activeItem]);

  const newUserArray = React.useMemo(() => {
    switch (activeItem) {
      case '0':
        // 返回按日的新增用户数据
        return array[4];
      case '1':
        // 返回按周的新增用户数据
        return [];
      case '2':
        // 返回按月的新增用户数据
        return array[0];
      default:
        // 默认返回空数组
        return [];
    }
  }, [activeItem, array]);

  const payUserArray = React.useMemo(() => {
    switch (activeItem) {
      case '0':
        // 返回按日的付费用户数据
        return array[5];
      case '1':
        // 返回按周的付费用户数据
        return [];
      case '2':
        // 返回按月的付费用户数据
        return array[1];
      default:
        // 默认返回空数组
        return [];
    }
  }, [activeItem, array]);
  const activeUserArray = React.useMemo(() => {
    switch (activeItem) {
      case '0':
        // 返回按日的活跃用户数据
        return array[6];
      case '1':
        // 返回按周的活跃用户数据
        return [];
      case '2':
        // 返回按月的活跃用户数据
        return array[2];
      default:
        // 默认返回空数组
        return [];
    }
  }, [activeItem, array]);
  const payAmountArray = React.useMemo(() => {
    switch (activeItem) {
      case '0':
        // 返回按日的付费金额数据
        return array[7];
      case '1':
        // 返回按周的付费金额数据
        return [];
      case '2':
        // 返回按月的付费金额数据
        return array[3];
      default:
        // 默认返回空数组
        return [];
    }
  }, [activeItem, array]);
  const getOption = React.useMemo(() => {
    return {
      tooltip: {
        trigger: 'axis',
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: timeArray,
        axisLabel: {
          interval: 0, // 设置为 0 以确保每个标签都显示
        },
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          name: '新增用户',
          type: 'line',
          data: newUserArray,
        },
        {
          name: '付费用户',
          type: 'line',
          data: payUserArray,
        },
        {
          name: '活跃用户',
          type: 'line',
          data: activeUserArray,
        },
      ],
    };
  }, [newUserArray, payUserArray, activeUserArray, timeArray]);

  const getPriceOption = React.useMemo(() => {
    return {
      tooltip: {
        trigger: 'axis',
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: timeArray,
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          name: '付费金额',
          type: 'line',
          data: payAmountArray,
        },
      ],
    };
  }, [payAmountArray, timeArray]);
  useEffect(() => {
    api.getStatistics().then((res) => {
      setArray([
        [...res.item.monthlyNewUsersCount],
        [...res.item.monthlyPaidUsers],
        [...res.item.monthlyActiveUserCounts],
        [...res.item.monthlyPaidAmount],
        [...res.item.dailyNewUsersCount],
        [...res.item.dailyPayUserCount],
        [...res.item.dailyActiveUsersCount],
        [...res.item.dailyPayAmountCount],
      ]);
      setStatistics(res.item);
    });
  }, []);

  const handleItemClick = (e, { name }) => {
    setActiveItem(name);
  };
  return (
    <div className={styles.app}>
      <div className={styles.box}>
        <ul className={styles.list}>
          <Popup
            content="用户表里未删除的用户"
            trigger={
              <li className={styles.item}>
                <h1>总用户数</h1>
                <p>{statistics.totalUsers}</p>
              </li>
            }
          />
          <Popup
            content="公司购买的人数相加，公司表里获取"
            trigger={
              <li className={styles.item}>
                <h1>付费企业数/用户数</h1>
                <p>
                  {statistics.workWechatPayNum}/{statistics.totalNumberOfPeople}
                </p>
              </li>
            }
          />
          <Popup
            content="所有有支付记录的订单折扣后的金额相加，如果没有折扣金额就是原价相加"
            trigger={
              <li className={styles.item}>
                <h1>总付费金额</h1>
                <p>{statistics.totalPrice}</p>
              </li>
            }
          />
          <Popup
            content="创建时间为当前月份的用户，从用户表里获取"
            trigger={
              <li className={styles.item}>
                <h1>本月新增用户</h1>
                <p>{statistics.newUsersThisMonth}</p>
              </li>
            }
          />
          <li className={styles.item}>
            <h1>本月付费企业数</h1>
            <p>{statistics.paidCompaniesThisMonth}</p>
          </li>
          <Popup
            content="创建时间为本月，且有支付记录的订单，订单里有人数，相加后获得，从订单表里获取"
            trigger={
              <li className={styles.item}>
                <h1>本月新增付费用户</h1>
                <p>{statistics.newPaidUsersThisMonth}</p>
              </li>
            }
          />
          <Popup
            content="创建时间为本月，且有支付记录的订单，订单里支付折扣金额相加后获得，没有折扣金额就原价相加，从订单表里获取"
            trigger={
              <li className={styles.item}>
                <h1>本月新增付费金额</h1>
                <p>{statistics.totalPaymentThisMonth.toFixed(2)}</p>
              </li>
            }
          />
        </ul>
        <div style={{ overflow: 'hidden' }}>
          <Menu floated="right">
            <MenuItem name="0" active={activeItem === '0'} onClick={handleItemClick}>
              日
            </MenuItem>
            <MenuItem name="2" active={activeItem === '2'} onClick={handleItemClick}>
              月
            </MenuItem>
          </Menu>
        </div>
        <ReactECharts option={getOption} />
        <ReactECharts option={getPriceOption} />
      </div>
    </div>
  );
});

Statistics.propTypes = {
  accessToken: PropTypes.string.isRequired,
};

export default Statistics;
